import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const FormContainer = styled.div`
background: ${props => props.isModal ? `${theme.colors.white.Branco}` : '#f8f8f9'};
display: flex;

form{
  margin-top: 40px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 400px;
}

i{
   margin-left: 15px;
 }

@media only screen and (max-width: 480px){
  form{
    width: 100%;
  }
}


`;

export const FormContainerEdit = styled.div`
margin-top: 20px;
/* background: #f8f8f9; */
display: flex;
width: 100%;
height: auto;
max-width: 400px;
margin: auto;
form{
  min-width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 400px;
}

i{
   margin-left: 15px;
 }
 @media only screen and (max-width: 991px){
    padding-left: 15px;
    padding-right: 15px;
   form{
     width: 100%;
   }
 }
`;

export const ContainerForm = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ButtonPlans = styled.div`
     width: 100%;
     display: flex;
     margin-top: 1.25rem;
     margin-bottom: 0.938rem;
     flex-direction: row;
     justify-content: center; 
`;

export const Container = styled.div`
  >div>div{
    max-width: 480px;
    padding: 16px 32px 32px;

    >div:last-child {
      margin-bottom: 0;

      >div{
        margin-bottom: 0;

        >div>div:last-child {
          margin-bottom: 0;

          >div{
            width: 100%
          }
        }
      }
    }

    @media (max-width: 843px) {
      max-width: 100%;
    }
  }
`;

export const ContainerContent = styled.div`
  width: 100%;
  height: auto;
  max-width: 28.75rem;

  >img{
      @media (max-width: 480px) {
            width: 8rem;
      }
    }

  >h5{
      margin-top: 1rem;

      @media (max-width: 480px) {
          font-size: 1.4rem;
      }
  }

  >p{
     margin-top: 1rem;

      >span{
        @media (max-width: 480px) {
          font-size: 1rem;
        }
      }

     @media (max-width: 480px) {
          font-size: 1rem;
      }
  }

  >p:nth-of-type(2){
      margin-top: 0.5rem;

      @media (max-width: 480px) {
            font-size: 0.9rem;
            line-height: 1rem;
      }
  }

    >div >div {
        >div:nth-of-type(1) {}

        >div:nth-of-type(2) {
          margin-bottom: 0;      
        }
    }
`;

export const ModalBody = styled.div`
  width: 100%;
  height: auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  text-align: ${props => props.textAlign ? props.textAlign : 'center'};
  margin-bottom: ${props => props.marginBottom ? props.marginBottom : '32px'} ;
`;

export const Label = styled.label`
  width: 100%;
  margin-bottom: 10px;
  margin-left: 15px;
  font-family: Lato;
  font-size: 11px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #8a92a2;
  display: inline-table;
  text-align: start;
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  width: 32px;
  height: 32px;
  position: relative;
  background-color: transparent;
  border-top: 1px solid ${theme.colors.green.Bandeira};
  border-bottom: 1px solid ${theme.colors.green.Bandeira};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;
